export default __webpack_public_path__ + "static/media/e13733178bbf1e53.fe39211f99c06d80b41d11c3d2f33f88.svg";